import React from 'react';
import styles from './LinkListElement.module.scss';
import { AppLink } from '../../AppLink/AppLink';

export interface LinkListElementProps {
  to: string;
  label: string;
}

export const LinkListElement = ({
  to,
  label
}: LinkListElementProps): React.ReactElement<LinkListElementProps> => {
  return (
    <li className={styles.linkListElement}>
      <AppLink to={to}>{label}</AppLink>
    </li>
  );
};
